namespace Solovis.Reports.Parts.Tables.DataTableHelpers.ExcelExport {

    export function showDialog(options) {
        var tableControl: DataTableControl = options.tableControl;

        var formDiv = $("<div>");

        var excelExportDiv = $("<div>").appendTo(formDiv);
        var excelExportControl = null;

        // Create advanced table link (view reference)
        var advancedTableDiv = $("<div>").css("float", "right").appendTo(excelExportDiv);
        var advancedTableLink = $("<a>").attr("title", "Advanced Options").html("<span class='fa fa-gear' />").appendTo(advancedTableDiv);


        var formBuilderDiv = $("<div>").appendTo(formDiv);
        var formBuilder = new Solovis.UI.InputControls.FormBuilder({
            container: formDiv,
            portalServices: tableControl.reportControl.portalServices()
        });

        formBuilder.addEntry({
            name: "rowMode",
            label: "Rows",

            initialValue: tableControl.rowDataExporter.getRowMode(),

            help: {
                text: "'All Data Rows' will export all source data rows for the table (client-side group rows will not be exported)."
                    + " 'Visible Rows' will export the list of rows currently visible (client-side filtering, sorting, and group settings will be applied)."
            },

            createEditor: function (createEditorOptions) {

                var editorControl = new Solovis.UI.InputControl({
                    container: createEditorOptions.container,
                    type: "select",
                    data: [
                        { text: "All Data Rows", value: "RawData" },
                        { text: "Visible Rows", value: "CurrentView" }
                    ],
                    value: createEditorOptions.initialValue,

                    change: function () {
                        let newRowMode = editorControl.value();
                        tableControl.rowDataExporter.setRowMode(newRowMode);
                    }
                });

                return editorControl;
            },
        });

        formBuilder.addEntry({
            name: "filterColumnIds",
            label: "Export Columns",
            
            initialValue: tableControl.rowDataExporter.getFilteredColumnIds(),

            applyStandardTextAlignTopPadding: true,

            createEditor: function (createEditorOptions) {                
                let container = createEditorOptions.container;

                let editor = {
                    exportColumnIds: createEditorOptions.initialValue,

                    getValue: function () {
                        return editor.exportColumnIds;
                    }
                };
                
                let fullExportMetadata = tableControl.rowDataExporter.getFullExportMetadata();

                let columnCountDiv = $("<div>").appendTo(container);

                let updateColumnCountDiv = function () {
                    columnCountDiv.html("");
                    if (_.isEmpty(editor.exportColumnIds)) {
                        columnCountDiv.append("All columns will be exported.");
                    }
                    else {
                        columnCountDiv.append("" + editor.exportColumnIds.length + " column(s) will be exported.");
                    }
                };

                updateColumnCountDiv();

                $("<button>").text("Select Columns").appendTo(container)
                    .click(function () {
                        let filterColumnExportDialog = new Solovis.Reports.Parts.Tables.Exports.FilterColumnExportDialog({
                            tableControl: tableControl,
                            initialSelectedColumnIds: editor.exportColumnIds,
                            fullExportMetadata: fullExportMetadata,
                            saveCallback: function (newExportColumnIds) {
                                editor.exportColumnIds = newExportColumnIds;
                                tableControl.rowDataExporter.setFilteredColumnIds(newExportColumnIds);
                                updateColumnCountDiv();
                            }
                        });
                        filterColumnExportDialog.show();
                    });

                return editor;
            }
        });
       
        // Allow reference to the specific table to be dragged from the website.
        Solovis.Site.DragDropManager.setupSolovisReportControlDrag(advancedTableLink, tableControl.reportControl, tableControl.partElementName);

        Solovis.UI.PopupLinkPanel.onElementClick(advancedTableLink, function (e) {
            var advancedLinks = [];

            advancedLinks.push({
                label: "View Table Reference",
                click: function () {
                    ExcelExport._showTableReference(tableControl);
                }
            });

            Solovis.UI.PopupLinkPanel.showLinks({
                offset: { left: e.pageX, top: e.pageY },
                links: advancedLinks
            });
        });

        let desiredWidth = Math.min($(window).width() * 0.9, 550);
        let desiredHeight = Math.min($(window).height() * 0.9, 350);

        var dialog = new Solovis.UI.Dialog({
            container: formDiv,

            title: "Excel Export",
            autoOpen: true,
            center: true,
            width: desiredWidth,
            height: desiredHeight,
            modal: true,
            destroyOnClose: true,
            actions: ["Close"],

            buttons: [
                {
                    label: "Export",
                    click: function () {
                        if (excelExportControl) {
                            excelExportControl.startExport();
                            dialog.close();
                        }
                    }
                },

                {
                    label: "Cancel",
                    click: function () {
                        dialog.close();
                    }
                }
            ],

            activate: function () {
                excelExportControl = new Solovis.Reports.Parts.Tables.DataTableHelpers.ExcelExport.ExcelExportControl({
                    controlHost: excelExportDiv,

                    tableControl: tableControl
                });

                excelExportControl.setAsCurrentControl();
            }
        });
    }


    export function _showTableReference(tableControl: Solovis.Reports.Parts.Tables.DataTableControl) {
        let reportRef = tableControl.reportControl.createReportReference(tableControl.partElementName);
        let reportRefJson = JSON.stringify(reportRef);

        var container = $("<div>");

        if (!tableControl.partElementName) {
            let elementNameWarning = $("<div>").css("margin-bottom", "10px").appendTo(container);

            elementNameWarning.text("WARNING: This table does not have 'elementName' defined in the report. This table will not"
                + " be individually exportable. Please ask the report author to add 'elementName' to enable exportability of this table.");
        }

        let linkInput = $("<textarea>").text(reportRefJson).attr("readonly", "readonly").appendTo(container)
            .css("width", "95%")
            .css("height", "150px");

        let helpText = $("<div>").text("Press Ctrl+C to copy table reference.").appendTo(container);

        let moreHelpText = $("<div>").css("margin-top", "15px").appendTo(container);
        moreHelpText.text("The 'Advanced Options' gear can be click-and-dragged into the Solovis Excel Plugin (or other compatible data analysis"
            + " tool) to create a reference to this specific table.");

        linkInput
            .mouseup(function () {
                $(this).select();
                $(helpText).toggle(true);
            })
            .focusout(function () {
                $(helpText).toggle(false);
            });

        let dialog = new Solovis.UI.Dialog({
            container: container,
            title: "Table Reference",
            autoOpen: true,
            center: true,
            destroyOnClose: true,
            actions: ["Close"],

            width: 600,
            height: 340,

            activate: function () {
                linkInput.select();
            }
        });
    }



    export class ExcelExportControl extends Solovis.UI.BaseControl {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public exportMetadata;
        public statusDiv: JQuery;
        public _exportStarted: boolean;

        constructor(options) {
            super(options);

            this.tableControl = options.tableControl;
        }


        public doInit() {            
        }

        public doRender() {
            var self = this;

            this.statusDiv = $("<div>").appendTo(this.container);
        }

        public startExport() {
            var self = this;

            if (this._exportStarted) {
                return;
            }

            this.exportMetadata = this.tableControl.rowDataExporter.getExportMetadata();

            this._exportStarted = true;

            let portalServices = this.tableControl.reportControl.portalServices();

            portalServices.rpc().invokeAndWait("~/DataExports/DataTableToExcel/CreateExportWorkItem", {},
                function (response, success) {
                    if (success) {
                        var tempDataItemId = response.result.tempDataItemId;

                        var metadataBlock = {
                            metadata: self.exportMetadata
                        };

                        var metadataBlockJson = JSON.stringify(metadataBlock);

                        portalServices.rpc().invokeAndWait("~/DataExports/DataTableToExcel/UploadTempItemDataBlock", { tempDataItemId: tempDataItemId, data: metadataBlockJson },
                            function (response, success) {
                                if (success) {
                                    self._uploadData(tempDataItemId);
                                }
                            });
                    }
                });
        }


        public _uploadData(tempDataItemId) {
            var self = this;

            var exportRows = [];

            this.tableControl.rowDataExporter.enumerateRows(this.exportMetadata, function (rowValues, rowTextValues) {
                exportRows.push(rowValues);
            });

            var exportData = {
                rows: exportRows
            };

            var exportDataJson = JSON.stringify(exportData);

            let portalServices = this.tableControl.reportControl.portalServices();

            portalServices.rpc().invokeAndWait("~/DataExports/DataTableToExcel/UploadTempItemDataBlock", { tempDataItemId: tempDataItemId, data: exportDataJson },
                function (response, success) {
                    if (success) {
                        self._afterDataUploaded(tempDataItemId);
                    }
                });
        }


        public _afterDataUploaded(tempDataItemId) {
            var self = this;

            let portalServices = this.tableControl.reportControl.portalServices();
            
            let tableName = "table_" + kendo.toString(new Date(), "yyyy-MM-dd_HH-mm-ss");

            portalServices.rpc().invokeAndWait("~/DataExports/DataTableToExcel/CreateSpreadsheet", { tempDataItemId: tempDataItemId },
                function (response, success) {
                    if (success) {
                        ($ as any).fileDownload(Solovis.resolveUrl("~/DataExports/DataTableToExcel/DownloadOutputData?tempDataItemId=" + tempDataItemId + "&name=" + encodeURIComponent(tableName), portalServices.siteUrl()), {
                            failCallback: function (html, url) {
                                self.statusDiv.text("Download Error: \r\n'" + html);
                            }
                        });
                    }
                });
        };
        
    }
    

}
